/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'fabric.editor.ai.ai-panel.actionItemsregenerateButtonLabel': "Rechercher des éléments d'action (bêta)",
  'fabric.editor.ai.ai-panels.actionItemsFeedbackButtonLabel': 'Donner un avis',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    "Utilisez Atlassian Intelligence pour trouver des éléments d'action et les afficher dans un panneau",
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': "Panneau des éléments d'action (bêta)",
  'fabric.editor.ai.ai-panels.actionItemsregenerateButtonTooltip':
    "Utilisez Atlassian Intelligence pour trouver des éléments d'action sur cette page",
  'fabric.editor.ai.ai-panels.contentQuality': 'La qualité du contenu est susceptible de varier',
  'fabric.editor.ai.ai-panels.contentQualityMayVary':
    'Le contenu est basé sur vos autorisations, et sa qualité peut varier. <link>En savoir plus</link>',
  'fabric.editor.ai.ai-panels.contentQualityMayVaryLabel':
    'Le contenu est basé sur vos autorisations, et sa qualité peut varier.',
  'fabric.editor.ai.ai-panels.logoAltText': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.ai-panels.poweredByAi': 'Optimisé par AI',
  'fabric.editor.ai.ai-panels.screens.loading.iconAltText': "Génération d'une icône",
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    "Utilisez Atlassian Intelligence pour résumer cette page et l'afficher dans un panneau",
  'fabric.editor.ai.ai-panels.summarizePageFeedbackButtonLabel': 'Donner un avis',
  'fabric.editor.ai.ai-panels.summarizePageRegenerateButtonLabel': 'Résumer la page (bêta)',
  'fabric.editor.ai.ai-panels.summarizePageRegenerateButtonTooltip':
    'Utilisez Atlassian Intelligence pour résumer cette page',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panneau de résumé de page (bêta)',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Génère du contenu à insérer dans la mise à jour',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Résume le contenu de la mise à jour',
  'fabric.editor.ai.config.item.action.insert': 'Insérer',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Insérer en haut',
  'fabric.editor.ai.config.item.action.insertBelow': 'Insérer en dessous',
  'fabric.editor.ai.config.item.action.replace': 'Remplacer',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Remplacer le titre',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Ouvrir dans le chat',
  'fabric.editor.ai.config.item.agent.title': 'Agent Rovo Atlassian Intelligence',
  'fabric.editor.ai.config.item.empty.bb.pr.description.description':
    'Crée une description de pull request avec un résumé des changements',
  'fabric.editor.ai.config.item.empty.bb.pr.description.title': 'Créer une description de pull request',
  'fabric.editor.ai.config.item.empty.brainstorm.description':
    "Génère une liste d'idées pour un sujet que vous proposez",
  'fabric.editor.ai.config.item.empty.brainstorm.promptHint': 'Dites-moi le thème…',
  'fabric.editor.ai.config.item.empty.brainstorm.promptLabel': 'Brainstorming',
  'fabric.editor.ai.config.item.empty.brainstorm.title': 'Brainstorming',
  'fabric.editor.ai.config.item.empty.findActionItems.description':
    "Trouve les éléments d'action dans le contenu fourni",
  'fabric.editor.ai.config.item.empty.findActionItems.title': "Rechercher des éléments d'action",
  'fabric.editor.ai.config.item.empty.generateContent.disabled.promptHint':
    'Faites votre choix ci-dessous (la génération libre est désactivée dans Elevate pour le moment)',
  'fabric.editor.ai.config.item.empty.generateContent.promptHint':
    "Écrivez avec AI ou sélectionnez l'une des options ci-dessous",
  'fabric.editor.ai.config.item.empty.suggestTitle.description': 'Suggère un titre pour le contenu fourni',
  'fabric.editor.ai.config.item.empty.suggestTitle.title': 'Suggérer un titre',
  'fabric.editor.ai.config.item.empty.summarizePage.description':
    'Crée un résumé du texte sur lequel vous travaillez, en soulignant les points clés',
  'fabric.editor.ai.config.item.empty.summarizePage.title': "Résumer l'écriture",
  'fabric.editor.ai.config.item.range.agent.description': 'Pas de description',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    "Demandez à l'agent d'écrire quelque chose ou choisissez parmi les options ci-dessous",
  'fabric.editor.ai.config.item.range.atlas-custom-shorten.description':
    'Raccourcit le contenu pour le rendre plus concis',
  'fabric.editor.ai.config.item.range.atlas-custom-shorten.title': 'Réduire la mise à jour',
  'fabric.editor.ai.config.item.range.changeTone.casualTone.description':
    'Fait passer le contenu à un style décontracté',
  'fabric.editor.ai.config.item.range.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Occasionnel',
  'fabric.editor.ai.config.item.range.changeTone.casualTone.shortTitle': 'Occasionnel',
  'fabric.editor.ai.config.item.range.changeTone.casualTone.title': 'Passer à un style décontracté',
  'fabric.editor.ai.config.item.range.changeTone.educationalTone.description':
    'Fait passer le contenu à un style pédagogique',
  'fabric.editor.ai.config.item.range.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Pédagogique',
  'fabric.editor.ai.config.item.range.changeTone.educationalTone.shortTitle': 'Pédagogique',
  'fabric.editor.ai.config.item.range.changeTone.educationalTone.title': 'Passer à un style pédagogique',
  'fabric.editor.ai.config.item.range.changeTone.empatheticTone.description':
    'Fait passer le contenu à un style empathique',
  'fabric.editor.ai.config.item.range.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empathique',
  'fabric.editor.ai.config.item.range.changeTone.empatheticTone.shortTitle': 'Empathique',
  'fabric.editor.ai.config.item.range.changeTone.empatheticTone.title': 'Passer à un style empathique',
  'fabric.editor.ai.config.item.range.changeTone.nestingParentTitle': 'Changer de ton',
  'fabric.editor.ai.config.item.range.changeTone.neutralTone.description': 'Fait passer le contenu à un style neutre',
  'fabric.editor.ai.config.item.range.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutre',
  'fabric.editor.ai.config.item.range.changeTone.neutralTone.shortTitle': 'Neutre',
  'fabric.editor.ai.config.item.range.changeTone.neutralTone.title': 'Passer à un style neutre',
  'fabric.editor.ai.config.item.range.changeTone.professionalTone.description':
    'Fait passer le contenu à un style professionnel',
  'fabric.editor.ai.config.item.range.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionnel',
  'fabric.editor.ai.config.item.range.changeTone.professionalTone.shortTitle': 'Professionnel',
  'fabric.editor.ai.config.item.range.changeTone.professionalTone.title': 'Passer à un style professionnel',
  'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.description':
    "Corrige les erreurs d'orthographe et de grammaire",
  'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Orthographe et grammaire',
  'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.title': "Corriger l'orthographe et la grammaire",
  'fabric.editor.ai.config.item.range.enhance.improveWriting.description':
    "Améliore la clarté, la structure et le ton pour améliorer l'engagement et la compréhension",
  'fabric.editor.ai.config.item.range.enhance.improveWriting.selectionToolbar.dropdownItem.title':
    "Améliorer l'écriture",
  'fabric.editor.ai.toolbar.improveWriting.title': "Améliorer l'écriture",
  'fabric.editor.ai.config.item.range.findActionItemsFromSelection.description':
    "Trouve les éléments d'action dans le contenu fourni",
  'fabric.editor.ai.config.item.range.findActionItemsFromSelection.title': "Rechercher des éléments d'action",
  'fabric.editor.ai.config.item.range.generateFromSelection.description': 'Générer à partir de la sélection',
  'fabric.editor.ai.config.item.range.generateFromSelection.disabled.description': 'Générer à partir de la sélection',
  'fabric.editor.ai.config.item.range.generateFromSelection.disabled.promptHint':
    'Faites votre choix ci-dessous (la génération libre est désactivée dans Elevate pour le moment)',
  'fabric.editor.ai.config.item.range.generateFromSelection.disabled.title': 'Atlassian Intelligence',
  'fabric.editor.ai.config.item.range.generateFromSelection.promptHint':
    "Demandez à AI d'écrire quelque chose ou de choisir parmi les options ci-dessous",
  'fabric.editor.ai.config.item.range.generateFromSelection.title': 'Atlassian Intelligence',
  'fabric.editor.ai.config.item.range.reformatWithTemplate.default.description':
    'Restructurez la description du ticket en fonction de son type',
  'fabric.editor.ai.config.item.range.reformatWithTemplate.default.title': 'Ajouter une structure',
  'fabric.editor.ai.config.item.range.reformatWithTemplate.default.title.experiment.one': 'Améliorer la description',
  'fabric.editor.ai.config.item.range.reformatWithTemplate.default.title.experiment.two':
    'Mettre en forme la description',
  'fabric.editor.ai.config.item.range.shorten.description': 'Raccourcit le contenu pour le rendre plus concis',
  'fabric.editor.ai.config.item.range.shorten.selectionToolbar.dropdownItem.title': 'Raccourcir',
  'fabric.editor.ai.config.item.range.shorten.title': 'Raccourcir',
  'fabric.editor.ai.config.item.range.suggest.description': 'Suggère un titre pour le contenu fourni',
  'fabric.editor.ai.config.item.range.suggest.title': 'Suggérer un titre',
  'fabric.editor.ai.config.item.range.summarize.description':
    'Crée un résumé du texte sur lequel vous travaillez, en soulignant les points clés',
  'fabric.editor.ai.config.item.range.summarize.dropdownItem.title': "Résumer l'écriture",
  'fabric.editor.ai.config.item.range.summarize.title': "Résumer l'écriture",
  'fabric.editor.ai.config.item.translate.nestingParentTitle': 'Traduire (bêta)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Traduit le texte sur lequel vous travaillez en chinois (simplifié)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Traduire en chinois (simplifié)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Traduit le texte sur lequel vous travaillez en chinois (traditionnel)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Traduire en chinois (traditionnel)',
  'fabric.editor.ai.config.item.translateTo.czech.description':
    'Traduit le texte sur lequel vous travaillez en tchèque',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Traduire en tchèque',
  'fabric.editor.ai.config.item.translateTo.danish.description':
    'Traduit le texte sur lequel vous travaillez en danois',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Traduire en danois',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Traduit le texte sur lequel vous travaillez en néerlandais',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Traduire en néerlandais',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Traduit le texte sur lequel vous travaillez en anglais',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Traduire en anglais',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Traduit le texte sur lequel vous travaillez en finnois',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Traduire en finnois',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Traduit le texte sur lequel vous travaillez en français',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Traduire en français',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Traduit le texte sur lequel vous travaillez en allemand',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Traduire en allemand',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Traduit le texte sur lequel vous travaillez en hongrois',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Traduire en hongrois',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Traduit le texte sur lequel vous travaillez en italien',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Traduire en italien',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Traduit le texte sur lequel vous travaillez en japonais',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Traduire en japonais',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Traduit le texte sur lequel vous travaillez en coréen',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Traduire en coréen',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Traduit le texte sur lequel vous travaillez en norvégien',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Traduire en norvégien',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Traduit le texte sur lequel vous travaillez en polonais',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Traduire en polonais',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Traduit le texte sur lequel vous travaillez en portugais (brésilien)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Traduire en portugais (brésilien)',
  'fabric.editor.ai.config.item.translateTo.russian.description':
    'Traduit le texte sur lequel vous travaillez en russe',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Traduire en russe',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Traduit le texte sur lequel vous travaillez en espagnol',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Traduire en espagnol',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Traduit le texte sur lequel vous travaillez en suédois',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Traduire en suédois',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Traduit le texte sur lequel vous travaillez en thaï',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Traduire en thaï',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Traduit le texte sur lequel vous travaillez en turc',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Traduire en turc',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Traduit le texte sur lequel vous travaillez en ukrainien',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Traduire en ukrainien',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Traduit le texte sur lequel vous travaillez en vietnamien',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Traduire en vietnamien',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Changer de ton',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Réécrire',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Traduire',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Nous rencontrons un problème pour insérer la réponse. Fermez la boîte de dialogue et réessayez.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    "Nous rencontrons un problème pour générer l'aperçu. Fermez la boîte de dialogue et réessayez.",
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    "Nous avons reçu trop de demandes récentes impliquant Atlassian Intelligence (AI). Réessayez dans quelques minutes ou découvrez-en plus sur <link>l'utilisation excessive d'AI</link>.",
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    "Impossible d'obtenir une réponse. Votre invite ou votre réponse a dépassé la limite fixée pour cette demande. Fermez la boîte de dialogue et réessayez.",
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Nous rencontrons un problème. Fermez la boîte de dialogue et réessayez.',
  'fabric.editor.ai.experience.apiError': "Impossible d'obtenir une réponse, veuillez réessayer.",
  'fabric.editor.ai.experience.aupViolationMessage':
    "Votre invite ou votre contenu peut ne pas être conforme à notre politique d'utilisation acceptable. Veuillez passer en revue les deux et consulter notre <auplink>politique d'utilisation acceptable</auplink>, si nécessaire. Si le problème persiste, essayez une autre invite ou un autre contenu.",
  'fabric.editor.ai.experience.browseMore.agents': 'Rechercher des agents',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Souhaitez-vous abandonner votre invite ?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Souhaitez-vous abandonner votre réponse ?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'La génération libre est désactivée dans Elevate pour le moment.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Optimisé par Rovo',
  'fabric.editor.ai.experience.hipaaContentError':
    "Atlassian Intelligence n'a pas pu traiter votre demande, car votre contenu comprend des liens vers du contenu soumis à des restrictions HIPAA. Veuillez supprimer ces liens, puis réessayer.",
  'fabric.editor.ai.experience.inputTooShortError':
    'Le contenu est trop court pour être résumé. Veuillez ajouter du contenu, puis réessayez.',
  'fabric.editor.ai.experience.internalServerError':
    "Atlassian Intelligence (AI) ne répond pas. Réessayez plus tard ou <link>vérifiez l'état d'AI</link>.",
  'fabric.editor.ai.experience.loadingTitle': 'Génération',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyse : examen de votre question.',
  'fabric.editor.ai.experience.messageTemplateContentSearch':
    'Recherche : veuillez patienter pendant que nous recherchons des informations.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask':
    'Recherche : veuillez patienter pendant que nous recherchons dans Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration':
    'Recherche : veuillez patienter pendant que nous recherchons dans la page.',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    "Atlassian Intelligence n'a aucune suggestion pour le moment. N'hésitez pas à essayer une autre invite ou un autre contenu.",
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agents',
  'fabric.editor.ai.floatingAiButton.tooltip': "Demander à Atlassian Intelligence d'écrire quelque chose",
  'fabric.editor.ai.persistentPlaceholder.text': "Saisissez /ai pour l'aide à la rédaction",
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Les demandes de génération de contenu faisant référence à des URL sont disponibles en version bêta.',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.spellingAndGrammar.suggestions.correct-suggestion': 'Suggestion correcte',
  'fabric.editor.ai.spellingAndGrammar.suggestions.dismiss': 'Ignorer la suggestion',
  'fabric.editor.ai.spellingAndGrammar.suggestions.improve-sentence.toolbar-button-label': 'Améliorer la phrase',
  'fabric.editor.ai.spellingAndGrammar.suggestions.incorrect-suggestion': 'Suggestion incorrecte',
  'fabric.editor.ai.spellingAndGrammarButton.tooltip': 'Vérifications orthographiques et grammaticales',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    "Dire à Atlassian Intelligence d'améliorer l'écriture de votre sélection",
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'rovo.agents.dropdown.title': 'Agents',
  'rovo.agents.dropdown.viewAgents.label': 'Afficher tous les agents',
};
